import {ON_SAFECUSTODY_CENTERS_LIST} from './../constants/ActionTypes';

const INIT_STATE = {
    safecustodycenters: []
} 

export default (state = INIT_STATE, action) => {
    switch(action.type){
        case ON_SAFECUSTODY_CENTERS_LIST :
            {
                return {
                    ...state,
                    safecustodycenters: action.payload
                };
            }
        default: {
            return state;
        }
    }
}